import app from '../app';

export default ['apiService', '$log', (apiService, $log) => {
  const svc = {
    currentCategory: null,
    currentCategoryTooltips: null,
    currentCategoryPromise: null,
    currentHomeownerFlag: null,
    currentMetersNotIncludedInPriceFlag: null,
  };

  svc.getCategoryTooltips = (category, isByHomeowner, showFlowMetersNotIncludedInPriceTooltips = null) => {
    /*
      Если прилетел запрос из другого поля объявления этой же категории, то возвращаем кэш
      Если кэша нет, но есть промис той же категории, то возвращаем промис
      Если прилетает первый запрос другой категории, сбрасываем кэш и создаем запрос
    */
    if (
      svc.currentCategory === category &&
      svc.currentHomeownerFlag === isByHomeowner &&
      svc.currentMetersNotIncludedInPriceFlag === showFlowMetersNotIncludedInPriceTooltips &&
      Array.isArray(svc.currentCategoryTooltips)
    ) {
      return Promise.resolve(svc.currentCategoryTooltips);
    }

    if (
      svc.currentCategory !== category ||
      svc.currentHomeownerFlag !== isByHomeowner ||
      svc.currentMetersNotIncludedInPriceFlag !== showFlowMetersNotIncludedInPriceTooltips
    ) {
      svc.currentCategoryTooltips = null;
      svc.currentCategoryPromise = null;
      svc.currentCategory = category;
      svc.currentHomeownerFlag = isByHomeowner;
      svc.currentMetersNotIncludedInPriceFlag = showFlowMetersNotIncludedInPriceTooltips;
    }

    const options = {
      category,
      isByHomeowner,
      showFlowMetersNotIncludedInPriceTooltips,
    };

    svc.currentCategoryPromise = svc.currentCategoryPromise || apiService.getTooltips(options);

    return svc.currentCategoryPromise.then(response => {
      const tooltipsReducer = (obj, tip) => {
        obj[tip.fieldName] = tip.text;
        return obj;
      };

      const tooltips = response.data.tooltips.reduce(tooltipsReducer, {});

      svc.currentCategoryTooltips = tooltips;

      return svc.currentCategoryTooltips;
    }, error => {
      svc.currentCategory = null;
      svc.currentHomeownerFlag = null;
      svc.currentMetersNotIncludedInPriceFlag = null;

      if (window.Raven) {
        window.Raven.captureException(new Error('Подсказки на ФП: не удалось загрузить подсказки'), {
          level: 'error',
        });
      }
      $log.error('Подсказки на ФП: не удалось загрузить подсказки');

      return {};
    });
  }

  return svc;
}];
